import styled from 'styled-components';

const StyledResourceIcon = styled('div')`
	display: flex;
	cursor: pointer;

	svg {
		width: 32px;
		height: 42px;
	}
`;

export { StyledResourceIcon };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/Table/ResourceIcon/styles.ts